export default __webpack_public_path__ + "static/char-s-sp01-ja-d233c47ca785aabe9eb2e3f5ffefc532.webp";